/**
 * Functionality specific to the public & internal portal.
 */
(async () => {
  // Add close button for mobile navigation.
  const nav = document.querySelector(".md-nav");

  const divCloseButton = document.createElement("button");
  divCloseButton.classList.add("close-button");
  divCloseButton.innerHTML = '<svg viewBox="0 0 24 24"><path d="M13.41406,12.00879l6.29297,6.29297l-1.41406,1.41406L12,13.42285l-6.29297,6.29297l-1.41406-1.41406l6.29297-6.29297L4.29297,5.71582l1.41406-1.41406L12,10.59473l6.29297-6.29297l1.41406,1.41406L13.41406,12.00879z"></path></svg>';

  nav.appendChild(divCloseButton);
  divCloseButton.addEventListener("click", function () {
    document.getElementsByClassName("md-icon md-header__button")[0].click();
  });

  // Add documentation-specific links to Community portal.
  const tocNav = document.querySelector(".md-sidebar--secondary nav.md-nav--secondary");
  if (tocNav) {
    let communityLinkHref = "https://developer.siemens.com/communities/index.html";
    for (const key in communityLinks) {
      if (window.location.pathname.startsWith(`/${key}`)) {
        communityLinkHref = communityLinks[key];
        break;
      }
    }

    const communityLink = document.createElement("a");
    communityLink.classList.add("join-community");
    communityLink.classList.add("community-image");
    communityLink.href = communityLinkHref;
    communityLink.textContent = "Join the community";
    tocNav.parentNode.appendChild(communityLink);

    const feedbackButton = document.createElement("a");
    feedbackButton.id = "provide-feedback-btn";
    feedbackButton.classList.add("join-community");
    feedbackButton.classList.add("feedback-image");
    feedbackButton.type = "button";
    feedbackButton.textContent = "Provide feedback";
    tocNav.parentNode.appendChild(feedbackButton);

    feedbackButton.addEventListener("click", async () => {
      try {
        const response = await fetch("/_auth/me");
        if (response.ok) {
          userInfo = await response.json();
          if (userInfo?.email) {
            openModal("feedback-modal");
          }
        } else {
          openModal("feedback-login");
          const feedbackLoginBtn = document.getElementById("feedbackLoginBtn");
          feedbackLoginBtn.addEventListener("click", () => {
            const userLoginLink = document.getElementById("userLoginLink");
            userLoginLink.click();
          });
        }
      } catch {
        // do nothing
      }
    });

    document.querySelectorAll(".close-modal").forEach((element) => {
      const dialog = element.closest(".modal");
      element.addEventListener("click", () => {
        closeModal(dialog.id);
      });
    });

    document.getElementById("submit-feedback-btn").addEventListener("click", () => {
      submitFeedback();
    });
  }
})();
let userInfo = {};
function openModal(id) {
  document.getElementById(id).setAttribute("open", true);
  document.getElementById(id).style.display = "flex";
}

function closeModal(id) {
  document.getElementById(id).removeAttribute("open");
  document.getElementById(id).style.display = "none";
  document.getElementById("feedback-text").value = "";
}

function submitFeedback() {
  const token = Cookies.get("TOKEN");
  const feedback = document.getElementById("feedback-text").value;

  if (feedback && token) {
    const feedbackText = `# Feedback from Developer Portal

    ## User email
    ${userInfo?.email}

    ## Page URL
    ${window.location.href}

    ## Feedback
    ${feedback}`;
    const hostname = window.location.hostname;
    let chatbotApiName = "chatbot-api";
    if (hostname.includes("internal")) {
      chatbotApiName = "chatbotint-api";
    }
    let baseUrl = `https://${chatbotApiName}.c2comms.cloud`;
    if (hostname.startsWith("dev.")) {
      baseUrl = `https://dev.${chatbotApiName}.c2comms.cloud`;
    } else if (hostname.startsWith("stage.")) {
      baseUrl = `https://stage.${chatbotApiName}.c2comms.cloud`;
    }

    fetch(`${baseUrl}/pulse-cloud-feedback`, {
      method: "POST",
      headers: {
        "Content-Type": "text/markdown",
        "Authorization": `Bearer ${token}`,
      },
      body: feedbackText,
    });
    closeModal("feedback-modal");
    openModal("feedback-success-modal");
  }
}
